import { useEffect } from 'react';
import { createRootRoute, Outlet, useRouter } from '@tanstack/react-router';
import { DatadogViewTracker } from '~portal/lib';
import { PortalBridge } from '~ui';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const router = useRouter();

  useEffect(() => {
    window.bridge = new PortalBridge(() => router.state.location.pathname);
    return () => {
      window.bridge = undefined;
    };
  }, [router]);

  return (
    <>
      <DatadogViewTracker />
      <Outlet />
    </>
  );
}
